import React from 'react'
import { Button } from 'components/ui'
import { useCreationText } from '../../hooks/useCreationText'
import styles from './styles.module.css'

interface ITaskNameStepProps {
  taskName: React.ReactNode
  ready: boolean
  disabled: boolean
  onStart: () => void
}

export function TaskNameStep({ taskName, ready, disabled, onStart }: ITaskNameStepProps) {
  const t = useCreationText()
  return (
    <div className={styles.intro}>
      <h2>{t.buildTask}</h2>
      <div className={styles.name}>
        <span className={styles.number} aria-hidden="true">
          1
        </span>
        {taskName}
      </div>
      <div className={styles.action}>
        {ready ? (
          <Button type="button" variant="primary" isDisabled={disabled} onClick={onStart}>
            {t.startBuilding}
          </Button>
        ) : (
          <p>{t.nameFirst}</p>
        )}
      </div>
    </div>
  )
}
